<app-products-search #prodSearch [(display)]="displayPS" [allowOld]="allowOld" [allowComplex]="allowComplex" [searchText]="searchText" (selectedProduct)="onProductSelection($event)"></app-products-search>

<p-autoComplete id="ProductSelectorDd"
                [(ngModel)]="product"
                [suggestions]="products"
                (completeMethod)="doSearch($event)"
                (onSelect)="onAutoCompleteSelect($event)"
                (onDropdownClick)="onDropdownClick($event)"
                [forceSelection]="true"
                field="PRODCODE"
                minLength="3"
                dropdown="true"
                [placeholder]="placeholder"
                dataKey="PRODID"
                (keydown)="$event.stopPropagation()"
                [style]="{'width':'85%'}">
</p-autoComplete>

